import React from "react";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import { staticPagesTabsData } from "../../../../data/SidebarData";
import Tabs from "../../../../Components/Common/Tabs";
import StaticContactForm from "./Components/StaticContactForm";

const StaticContact = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={staticPagesTabsData} />
      <StaticContactForm title="Contact" customSlug="contact-us" />
    </div>
  );
};

export default StaticContact;

